import { render } from "./CategoryRepartition.vue?vue&type=template&id=702222da&scoped=true"
import script from "./CategoryRepartition.vue?vue&type=script&lang=js"
export * from "./CategoryRepartition.vue?vue&type=script&lang=js"

import "./CategoryRepartition.vue?vue&type=style&index=0&id=702222da&scoped=true&lang=css"
/* custom blocks */
import block0 from "./CategoryRepartition.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_09d06e80%2Fpackages%2Finsurer%2Fsrc%2Fcomponents%2FCategoryRepartition.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702222da"]])

export default __exports__